<template>
  <div v-if="section" class="flex flex-col items-center w-full gap-5">
    <div
      :id="`section_field_${section.id}`"
      class="flex flex-col w-full gap-2 px-4 py-5 border-l-8 lg:w-148 lg:px-10 bg-pure-white border-red-salmon rounded-xl"
    >
      <BlTextSubtitle2 :text="section.name" />
      <BlTextBody2
        v-if="section.description"
        :text="section.description"
        class="whitespace-pre-line text-slate-800"
      />
    </div>
    <ProspectFormQuestion
      v-for="question in section.questions"
      :key="question.id"
      :sectionId="section.id"
      :question="question"
    />
  </div>
</template>

<script>
import ProspectFormQuestion from "./Question.vue";

import BlTextSubtitle2 from "../../BlTextSubtitle2.vue";
import BlTextBody2 from "../../BlTextBody2.vue";

export default {
  name: "ProspectFormSection",
  components: {
    ProspectFormQuestion,
    BlTextSubtitle2,
    BlTextBody2
  },
  props: {
    section: { type: Object, required: true }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/form/prospectForm/Section.vue